export const ContainerTurnoverSizes = {
  20: 20,
  40: 40,
  45: 45,
}
